import { Fragment, useState, useRef, useEffect } from "react";

import { useDispatch } from "react-redux";

import BackButtonComponent from "../../../../NewComponents/BackButton/BackButton.component";
import { useLocation, useHistory } from "react-router-dom";
import Alert from "../../../../NewComponents/TypedComponents/Alert/Alert.component";
import { appInsights } from "../../../../config/appInsights";
import CustomInputField from "../../../CustomHTMLElements/CustomInputField";
import TierCheckList from "../../Components/Tier";
import TierUpgradeReviewModal from "../../Components/TierUpgradeReviewModal";
import { showModal } from "../../../../redux/actions/modal";
import { UpradeType } from "../../Interfaces";
import {
  IPendingTierUpgradeRequest,
  IBvnDetails,
  INinDetails,
} from "../../../../custom-hooks/usePendingTierUpgradeRequests";
import { DownloadUploadedDocument } from "../../../../NewComponents/UploadedDocumentCards/UploadedDocumentCard.component";
import useDocumentViewer from "../../../../NewComponents/CustomViewDocumentHandler/CustomViewDocumentHandler";

import styles from "./reviewTierUpgradeRequest.module.scss";
import CustomTextArea from "../../../../NewComponents/TypedComponents/CustomHTMLElements/CustomTextArea";

const ReviewTierUpgradeRequest = () => {
  const [modalActionType, setModalActionType] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const { handleViewDocument } = useDocumentViewer();

  const dismissModalRef = useRef();
  const { state } = useLocation();

  const {
    tier,
    data: {
      accountNumber,
      bvn,
      bvnDetails,
      dateCreated,
      email,
      firstName,
      gender,
      id,
      isAddressVerified,
      isBvnVerified,
      isNinVerified,
      kycRequestDate,
      lastName,
      nin,
      ninDetails,
      phoneNumber,
      transactionLimit,
      picturePath,
      governmentIdInfo,
      employmentDetails,
      residentialDetails,
      proofOfAddressInfo,
      addressVerificationStatus,
      addressVerificationInfo,
    },
  } = state as {
    tier: UpradeType;
    data: IPendingTierUpgradeRequest;
  };

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    appInsights.trackPageView({
      name: "Review Tier Upgrade Request",
      isLoggedIn: true,
    });
  }, []);

  const tierTwoItems = [
    {
      id: 1,
      name: "BVN Verification",
      status: Object.keys(bvnDetails || {}).length > 0,
    },
    {
      id: 2,
      name: "NIN Verification",
      status: Object.keys(ninDetails || {}).length > 0,
    },
    {
      id: 3,
      name: "Address Verification",
      status: addressVerificationStatus === "Verified",
    },
  ];

  const tierThreeItems = [
    {
      id: 1,
      name: "Proof Of Address",
      status: proofOfAddressInfo?.status?.name === "Approved",
    },

    {
      id: 2,
      name: "Source of Income",
      status: Object.keys(employmentDetails?.sourceOfIncome || {}).length > 0,
    },
  ];

  const handleViewUserInformation = (
    bvnDetails: IBvnDetails,
    ninDetails: INinDetails,
    _picturePath: string
  ) => {
    dispatch(
      showModal({
        modalIdentifier: "bvnandnindetails",
        dataRecord: { bvnDetails, ninDetails, _picturePath },
      })
    );
  };

  return (
    <Fragment>
      {error && <Alert message={error} />}
      {success && <Alert message={success} type="success" />}
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <h3 className="page-title d-flex align-items-center">
          <BackButtonComponent /> Review Request
        </h3>
        <div className="d-flex align-items-center justify-content-end">
          <div>
            <button
              className="btn advancly-btn btn-md mr-2"
              data-toggle="modal"
              data-target="#addReviewTierUpgradeModal"
              onClick={() => setModalActionType("approve")}
            >
              Upgrade Tier
            </button>
            <button
              className="btn advancly-white-btn btn-md"
              data-toggle="modal"
              data-target="#addReviewTierUpgradeModal"
              onClick={() => setModalActionType("decline")}
            >
              Decline Tier
            </button>
          </div>
        </div>
      </div>
      <div className={styles.profileArea}>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>Customer's Name</div>
          <div className={styles.content}>{`${firstName} ${lastName}`}</div>
        </div>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>Customer Email</div>
          <div className={styles.content}>{email}</div>
        </div>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>Customer Phone No.</div>
          <div className={styles.content}>{phoneNumber}</div>
        </div>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>KYC Upgrade Request Date</div>
          <div className={styles.content}>{kycRequestDate}</div>
        </div>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>Tier</div>
          <div className={styles.content}>Tier {tier}</div>
        </div>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>Transaction Limit</div>
          <div className={styles.content}>
            {transactionLimit ? transactionLimit : "NIL"}
          </div>
        </div>
        <div className={styles.profileAreaCard}>
          <div className={styles.title}>Account Number</div>
          <div className={styles.content}>{accountNumber}</div>
        </div>
      </div>

      <div className={`row pl-2 pr-2 ${styles.documentsContainer}`}>
        <div className={`col-sm-5 col-xs-12 ${styles.availableDocs}`}>
          <h4 className={styles.title}>Available Docs</h4>
          <p className={styles.subTitle}>Tier {tier} Upgrade upload</p>

          {tier === UpradeType.TIER_TWO && (
            <div>
              <div className="mt-5">
                <CustomInputField
                  label="BVN"
                  type="text"
                  name="searchQuery"
                  disabled
                  defaultValue={bvn}
                />
              </div>
              <div className="mt-5">
                <CustomInputField
                  label="NIN"
                  type="text"
                  name="searchQuery"
                  disabled
                  defaultValue={nin}
                />
              </div>

              <div className="mt-5">
                <label className="form-label m-0">Government Issued ID</label>
                <div className="mt-n1">
                  <DownloadUploadedDocument
                    name={governmentIdInfo?.idType}
                    pathname={governmentIdInfo?.uploadPath}
                    handleView={() =>
                      handleViewDocument(false, governmentIdInfo?.uploadPath)
                    }
                  />
                </div>
              </div>
            </div>
          )}

          {tier === UpradeType.TIER_THREE && (
            <div>
              <div className="mt-5">
                <CustomTextArea
                  label="Residential Address"
                  defaultValue={residentialDetails?.address}
                  disabled
                />
              </div>
              <div className="mt-5">
                <CustomInputField
                  label="Source of Income"
                  type="text"
                  name="searchQuery"
                  disabled
                  defaultValue={employmentDetails?.sourceOfIncome?.name}
                />
              </div>

              <div className="mt-5">
                <label className="form-label m-0">Proof of Address</label>
                <div className="mt-n1">
                  <DownloadUploadedDocument
                    name={proofOfAddressInfo?.idType}
                    pathname={proofOfAddressInfo?.uploadPath}
                    handleView={() =>
                      handleViewDocument(false, proofOfAddressInfo?.uploadPath)
                    }
                  />
                </div>
              </div>
              <div className="mt-5">
                <CustomTextArea
                  extraLabel={addressVerificationStatus}
                  label="Address Verification"
                  disabled
                  defaultValue={
                    addressVerificationInfo?.location?.formatted_address
                  }
                />
                <div>
                  {/* <button
                    className="btn advancly-white-btn btn-md mr-2"
                    onClick={() => {
                      if (addressVerificationInfo?.location?.url) {
                        window.open(
                          addressVerificationInfo.location.url,
                          "_blank"
                        );
                      }
                    }}
                  >
                    View Certificate
                  </button> */}
                  <button
                    className="btn advancly-white-btn btn-md"
                    onClick={() => {
                      if (addressVerificationInfo?.location?.url) {
                        window.open(
                          addressVerificationInfo.location.url,
                          "_blank"
                        );
                      }
                    }}
                  >
                    View Location
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* <div>
            <button className="btn advancly-btn btn-md mr-2">
              Verify Address
            </button>
          </div> */}
        </div>
        <div className={`col-sm-7 col-xs-12 ${styles.checklistContainer}`}>
          <div className={styles.checkList}>
            <h4 className={styles.title}>Checklist Items</h4>
            {tier === UpradeType?.TIER_THREE && (
              <>
                <div className="mb-4">
                  <TierCheckList name="Tier 3" items={tierThreeItems} />
                </div>
                <div className="mb-4">
                  <TierCheckList name="Tier 2" items={tierTwoItems} />
                </div>
              </>
            )}

            {tier === UpradeType?.TIER_TWO && (
              <>
                <div className="mb-4">
                  <TierCheckList name="Tier 2" items={tierTwoItems} />
                </div>
              </>
            )}

            <p
              className={styles.viewBvnNinAction}
              onClick={() =>
                handleViewUserInformation(bvnDetails, ninDetails, picturePath)
              }
            >
              View Customer's BVN & NIN Information
            </p>
          </div>
        </div>
      </div>

      <TierUpgradeReviewModal
        dismissModalRef={dismissModalRef}
        modalActionType={modalActionType}
        loading={loading}
      />
    </Fragment>
  );
};

export default ReviewTierUpgradeRequest;
